export type OneTimePurchaseStatus =
	| "canceled"
	| "processing"
	| "requires_action"
	| "requires_capture"
	| "requires_confirmation"
	| "requires_payment_method"
	| "succeeded"
	| "all";

interface OneTimePurchase {
	id: string;
	status: OneTimePurchaseStatus;
	quantity: number;
	businessProfileId: number;
}

export class OneTimePurchaseModel implements OneTimePurchase {
	id: string;
	status: OneTimePurchaseStatus;
	quantity: number;
	businessProfileId: number = 0;

	constructor(id: string, status: OneTimePurchaseStatus, quantity: number) {
		this.id = id;
		this.status = status;
		this.quantity = quantity;
	}

	get quantityIfActiveStatus() {
		return this.status === "succeeded" ? this.quantity : 0;
	}

	static generateFromAPI(data: any) {
		return new OneTimePurchaseModel(data.id, data.status, data.quantity);
	}

	static generateFromObject = (data: OneTimePurchase): OneTimePurchaseModel => {
		return new OneTimePurchaseModel(data.id, data.status, data.quantity);
	};

	static generateEmpty = (): OneTimePurchaseModel => {
		return new OneTimePurchaseModel("", "all", 0);
	};
}
